import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader
} from '@coreui/react';

import { apiClient } from 'services/Api';
import DataTableComponent from "components/DataTableComponent";
import AlertNotification from 'components/globals/AlertNotification';
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";

const InternshipList = () => {
    const navigate = useNavigate();
    const [internships, setInternships] = useState([]);
    const location = useLocation();
    const [previewInternship, setPreviewInternship] = useState(null);

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const response = await apiClient.get(`/internships/`);
                setInternships(response.data);
                setPreviewInternship((current) => current
                    ? response.data.find((internship) => internship.id === current.id) || null
                    : null);
            } catch (error) {
                console.error('Error fetching internships:', error);
            }
        };

        fetchSuppliers();
    }, [location.pathname]);

    const handleDelete = async (internshipId) => {
        try {
            await apiClient.delete(`/internships/${internshipId}/`);
            setInternships((current) => current.filter((internship) => internship.id !== internshipId));
            setPreviewInternship((current) => current?.id === internshipId ? null : current);
        } catch (error) {
            console.error('Error deleting internship:', error);
        }
    };

    const columns = [
        { name: "Nome", selector: (row) => row.name, sortable: true, className: 'text-center' },
        { name: "Entidade", selector: (row) => row.institution, sortable: true, className: 'text-center' },
        { name: "Data de Início", selector: (row) => row.start_date, sortable: true, className: 'text-center' },
        { name: "Data de Fim", selector: (row) => row.end_date, sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Estágios</h3>
                    <Link to="/estagios/new">
                        <CButton color="info" className="text-white">Novo Estágio</CButton>
                    </Link>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={internships}
                        onRowClicked={setPreviewInternship}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewInternship}
                onHide={() => setPreviewInternship(null)}
                title="Estágio"
                subtitle={previewInternship?.name}
                fields={previewInternship ? [
                    { label: "Nome", value: previewInternship.name },
                    { label: "Entidade", value: previewInternship.institution },
                    { label: "Data de Início", value: previewInternship.start_date },
                    { label: "Data de Fim", value: previewInternship.end_date },
                ] : []}
                headerActions={previewInternship && <>
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/estagios/${previewInternship.id}`)}>
                        Ver/Editar
                    </CButton>
                    <CButton color="danger" size="sm" className="text-white" onClick={() => handleDelete(previewInternship.id)}>
                        Eliminar
                    </CButton>
                </>}
            />
        </>
    );
};

export default InternshipList;
